import { AuthorizeAction } from 'modules/core/components/AuthorizeExpiredTrial'
import { Subscription } from 'modules/core/hooks/useCurrentSession'

interface Props {
  disableClick?: boolean
  disabled?: boolean
  className?: string
  onClick?: React.MouseEventHandler<HTMLElement>
  onDrop?: React.DragEventHandler<HTMLElement>
  subscription: Subscription
}

export function Authorized(props: React.PropsWithChildren<Props>) {
  if (props.subscription.inExpiredFreeTrial) {
    return AuthorizeAction(props)
  }

  return <>{props.children}</>
}
